import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
/**
 * List of the object types that have the "Activity" tab.
 */
export const ACTIVITY_ALLOW_LIST = {
  [OBJECT_TYPE.CAMPAIGN]: {
    gates: []
  }
};
export function hasActivityFeed(objectType, hasGate) {
  if (ACTIVITY_ALLOW_LIST[objectType]) {
    if (ACTIVITY_ALLOW_LIST[objectType].gates) {
      return ACTIVITY_ALLOW_LIST[objectType].gates.every(hasGate);
    }
    return true;
  }
  return false;
}